import * as React from 'react';
import * as styled from './styled';
import {useContext} from '../../hooks/useContext';

/**
 * The header of a block.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Header(): React.ReactElement {
  const {block} = useContext();

  /**
   * Render question.
   * @return {JSX.Element}
   */
  function renderQuestion(): JSX.Element {
    return (
      <styled.Question>
        {block.question}
      </styled.Question>
    );
  }

  /**
   * Render description.
   * @return {JSX.Element | undefined}
   */
  function renderDescription(): JSX.Element | undefined {
    return block.description ? (
      <styled.Description>
        {block.description}
      </styled.Description>
    ) : undefined;
  }

  return (
    <styled.Wrapper>
      {renderQuestion()}
      {renderDescription()}
    </styled.Wrapper>
  );
}
